import { toast } from "react-toastify";

export const showInfo = (text) => toast.info(text);

export const showSuccess = (text) => toast.success(text);

export const showWarning = (text) => toast.warn(text);

export const showError = (text) => toast.error(text);
